import { useHttp } from "../index";
import { QuizStatusProps } from "./types";

export const useGetQuizStatus = (quizId: string) =>
  useHttp<QuizStatusProps>(`/quiz/${quizId}/`, {
    method: "get",
  });
